import React, { useState, useEffect } from 'react';
import './style.scss';
import Logo from '../../../../assets/images/FabLogo.svg';
import { TextField } from '@mui/material';
import Button from '../../../Shared/components/controls/Button/index';
import { withTranslation } from 'react-i18next';
import { SitecoreContext, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import Loader from '../../../IBANGeneratorComponent/Loader/index';
import config from '../../../../Config';
import { set } from 'lodash';
const StepOne = ({
  t,
  setActiveStep,
  nationalId,
  setNationalId,
  passportNumber,
  setPassportNumber,
  creditCardLastFour,
  setCreditCardLastFour,
  ExtraUserDetailsEndpoint,
  IsMockExtraUserDetailsEndpoint,
  i18n,
}) => {
  const [nationalIdError, setNationalIdError] = useState('');
  const [passportError, setPassportError] = useState('');
  const [creditCardError, setCreditCardError] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);
  const [isPassportSelected, setIsPassportSelected] = useState(false);
  const [isUserBankCustomer, setIsUserBankCustomer] = useState(false);
  const [isUserBankCustomerError, setIsUserBankCustomerError] = useState('');
  const [loading, setLoading] = useState(false);
  const maxCharsForNationalIDField = 14; // Character limit
  const maxCharsForPassportNumberField = 11; // Character limit
  const maxCharsForCreditCardField = 4; // Character limit

  const validateNationalId = (value) => {
    if (!value) return '';
    const regex =
      /^([2-3]{1})([0-9]{2})(0[1-9]|1[012])(0[1-9]|[1-2][0-9]|3[0-1])(0[1-4]|[1-2][1-9]|3[1-5]|88)[0-9]{3}([0-9]{1})[0-9]{1}$/;
    return regex.test(value) ? '' : t('NationalIdFormatValidation');
  };

  const validatePassport = (value) => {
    if (!value) return '';
    const regex = /^[a-zA-Z0-9]+$/;
    return regex.test(value) ? '' : t('InvalidPassportNumberformat');
  };

  const validateCreditCard = (value) => {
    const regex = /^\d{4}$/;
    if (!value) {
      return t('CreditCardValidation');
    }
    if (!regex.test(value)) {
      return t('CreditCardDigitsValidation');
    }
    return '';
  };

  const handleNationalIdChange = (event) => {
    const value = event.target.value;
    if (value.length > maxCharsForNationalIDField) return t('NationalIdFormatValidation');
    setNationalId(value);
    setNationalIdError(validateNationalId(value));
  };

  const handlePassportChange = (event) => {
    const value = event.target.value;
    if (value.length > maxCharsForPassportNumberField) return t('InvalidPassportNumberformat');
    setPassportNumber(value);
    setPassportError(validatePassport(value));
  };

  const handleCreditCardChange = (event) => {
    const value = event.target.value;
    if (value.length > maxCharsForCreditCardField) return t('CreditCardDigitsValidation');
    setCreditCardLastFour(value);
    setCreditCardError(validateCreditCard(value));
  };
  const checkIfUserisRegistered = async () => {
    const isPassportNumber = !!passportNumber;
    const referenceNumber = isPassportNumber ? passportNumber : nationalId;

    const isUserRegistered = await CheckIfUserisRegistered(referenceNumber, isPassportNumber);

    if (isUserRegistered && isUserRegistered.StatusCode === 200 && isUserRegistered.Data === true) {
      setIsUserBankCustomer(true);
      setIsUserBankCustomerError('');
      console.log('Extra User Details response:', isUserRegistered.Data);
      return isUserRegistered.Data;
    } else {
      // Handle failed OTP generation (optional feedback)
      console.warn('Failed to generate OTP');
      setIsUserBankCustomer(false);
      setIsUserBankCustomerError(t('IsUserBankCustomerErrorMsg'));
      return false;
    }
  };
  const CheckIfUserisRegistered = async (referenceNumber, isPassportNumber) => {
    try {
      const url = `${config.hostname}/api/extrauserdata/CheckIfUserisRegistered?ReferenceNumber=${referenceNumber}&IsPassportNumber=${isPassportNumber}&Lang=${i18n.language}&IsMock=${IsMockExtraUserDetailsEndpoint}`;
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Failed to fetch extra user details');
      }
      const data = await response.json();
      return data; // Return data for further processing
    } catch (error) {
      throw error; // Rethrow to handle in the calling function
    }
  };

  useEffect(() => {
    const isValid =
      !creditCardError &&
      creditCardLastFour &&
      ((nationalId && !nationalIdError) || (passportNumber && !passportError));
    setIsFormValid(isValid);
  }, [
    nationalId,
    nationalIdError,
    passportNumber,
    passportError,
    creditCardLastFour,
    creditCardError,
  ]);

  const handleSubmit = async () => {
    setLoading(true); // Start loading at the beginning
    try {
      const isRegistered = await checkIfUserisRegistered();

      // Ensure `checkIfUserisRegistered` returns the required data and validate conditions
      if (isRegistered && isFormValid) {
        setActiveStep(2); // Move to the next step if all conditions are met
      } else {
        console.warn('User registration or form validation failed.');
      }
    } catch (error) {
      console.error('Failed to check if user is registered:', error);
      // You can handle the error further, like showing a user-friendly message
    } finally {
      setLoading(false); // Ensure loading state is turned off after execution
    }
  };
  if (loading) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  }
  return (
    <div className="ParentCont">
      <div className="StepOneContainer">
        {/* Logo */}

        {/* first Section */}
        {/* <div className="sectionContainer">
          <span className="sectionTitle">{t('StepOneTitle')}</span>
          <span className="sectionDesc">{t('stepOneSubtitleDescription')}</span>
        </div> */}

        {/* title Section */}
        <div className="titleContainer">
          <span className="title"> {t('PersonalDetails')} </span>
          <span className="subTitle">{t('PersonalDetailsSubtitle')}</span>
        </div>

        {/* identification section */}
        <div className="idContainer">
          <span className="idTitle">{t('Identification')}</span>
          <div className="tabContainer">
            <div className="tabs">
              <button
                className={`tab ${!isPassportSelected ? 'active' : ''}`}
                onClick={() => {
                  setIsPassportSelected(false);
                  setPassportNumber('');
                  setPassportError('');
                }}
              >
                {t('NationalIDNumber')}
              </button>
              <div className="divider" />
              <button
                className={`tab ${isPassportSelected ? 'active' : ''}`}
                onClick={() => {
                  setIsPassportSelected(true);
                  setNationalId('');
                  setNationalIdError('');
                }}
              >
                {t('PassportNumber')}
              </button>
            </div>
            <div className="tabContent">
              {!isPassportSelected ? (
                <TextField
                  variant="outlined"
                  label={t('NationalIDNumber')}
                  className="input"
                  value={nationalId}
                  onChange={handleNationalIdChange}
                  error={!!nationalIdError}
                  helperText={nationalIdError}
                  //onBlur={() => checkIfUserisRegistered()}
                />
              ) : (
                <TextField
                  variant="outlined"
                  label={t('PassportNumber')}
                  className="input"
                  value={passportNumber}
                  onChange={handlePassportChange}
                  error={!!passportError}
                  helperText={passportError}
                  //onBlur={() => checkIfUserisRegistered()}
                />
              )}
            </div>
          </div>
        </div>

        {/* credit section */}
        <div className="creditSection">
          <span className="creditTitle">{t('CreditCardDetailsText')}</span>
          <div className="creditContainer">
            <TextField
              label={t('CreditCardLabel')}
              variant="outlined"
              className="input"
              value={creditCardLastFour}
              onChange={handleCreditCardChange}
              error={!!creditCardError}
              helperText={creditCardError}
            />
          </div>
        </div>

        {/* button section */}
        <div className="generic-error">
          {isUserBankCustomerError && <span>{isUserBankCustomerError}</span>}
        </div>
      </div>
      <div className="btnContainer">
        <Button className="submitBtn" onClick={handleSubmit} disabled={!isFormValid}>
          {t('Continue')}
        </Button>
      </div>
    </div>
  );
};

export default withTranslation()(withSitecoreContext()(StepOne));
